import React, { Component } from "react";
import Form from "react-jsonschema-form";
import {Button ,Well,ButtonGroup,Glyphicon,ToggleButtonGroup,ToggleButton,ControlLabel,FormGroup,FormControl,HelpBlock,InputGroup} from "react-bootstrap";

import {ActionsDisplay} from "./ActionsDisplay"
import ActionCreate from './ActionCreate'
import ReactDragList from 'react-drag-list'
import Moment from 'react-moment';
import moment from "moment"


const temperatureLogic={
 "Description": "Auto generated temperature alert",
 "active_duration": 1800,
 "level": 3,
 "MacroFalse": "",
 "enabled": true,
 "state": false,
 "type":"TEMPERATURE_LOGIC",
 "MacroTrue": "map-to-macro!!!",
 "logic": [
  {
   "data": {
    "v1": {
     "var": "inputXfiltered",
     "value": 0
    },
    "v2": {
     "value": -10
    }
   },
   "opperator": ">="
  }
 ],
 "name": "Temperature Alert"
}

const alertMacro= {
 "name": "AlertList",
 "actions": [
  {
   "message": "maps-to-logic-id",
   "cmd": "alertlist",
   "list": "CONTACT_TREE2",
   "online": true
  }
 ]
}


function ShowContactOption(props){
  let d=props.data
  console.log("Contact list!")
  console.log(props)
  if(d.type=="CONTACT_LIST"){
    return <option value={d.id} key={d.id}>{d.name}</option>
  }
  return ("")
}

function ShowTempOption(props){

    let l=props.data
    console.log(l)
    if(l.type==512){
        return (<option key={l.id} value={"input"+l.id+"filtered"}>{l.name} ({l.state}°C)</option>)
    }
    return ("")
}



export default class TempAlert extends Component {
    constructor(props) {
      super(props);
      this.state = {
        data:props.data,
        vars:props.vars,
        macro:props.macro,
        id:props.logicid,
        edit:props.edit,
        showEdit:false,
        editIndex:0,
        newAction:false,
        addNew:false,
        nameEdit:false,
        redraw:true,
        macroList:{"enum": [], "enumNames": []}
      };

    }

  componentWillMount() {










    if(this.props.new==true){
      console.log("New Logic")
        let logic_template=temperatureLogic
        logic_template.MacroTrue="MAC-"+this.props.logicid
        let macro_template=alertMacro
        macro_template.actions[0].message=this.props.logicid
        this.setState({id:this.props.logicid})
        this.setState({data:temperatureLogic})
        this.setState({macro:macro_template})
    }
    else{
      console.log("Edit Logic")

      //macro has been deleted
      if(this.state.macro==undefined){
        let macro_template=alertMacro
        macro_template.actions[0].message=this.props.logicid
        this.setState({macro:macro_template})
      }

      console.log(this.props.data)

        this.setState({data:this.props.data})
        this.setState({id:this.props.logicid})




    }


  }


    updatedSensor=(e)=>{
      console.log("Change the sensor we are mapping to")
      //logic --> v1 --> var....
      console.log(e.target.value)
      let temp=this.state.data
      temp.logic[0].data.v1.var=e.target.value
      this.setState({data:temp})

//{this.state.data.logic[0].data.v1.var}

    }

updatedContactList=(e)=>{

  console.log(e.target.value)
  let temp=this.state.macro
  temp.actions[0].list=e.target.value
  this.setState({macro:temp})




}

    changeDuration=(e)=>{
      console.log("Change the amount of time the sensor has to be above/below desired value")
      console.log(e)
      let temp=this.state.data
      temp.active_duration=e
      this.setState({data:temp})
    }

    changeTemp=(e)=>{
      console.log("Change the temperature that the condition is compared against!!!")
      console.log(e.target.value)
      console.log(e.target)
      if(e.target.value==""){
        console.log("-ve")
        let temp=this.state.data
        temp.logic[0].data.v2.value=v
        this.setState({data:temp})
        return
      }



      let v=parseInt(e.target.value)
      if(v>80){
        v=80
      }
      if(v<-40)
        v=-40
      let temp=this.state.data
      temp.logic[0].data.v2.value=parseInt(v)
      this.setState({data:temp})
    }


    changeLevel=(e)=>{
      let temp=this.state.data
      temp.logic[0].level=e
      this.setState({data:temp})
    }


    changeOpperator=(e)=>{
      console.log("Change more than or less than")
      console.log(e)
      let temp=this.state.data
      temp.logic[0].opperator=e
      this.setState({data:temp})
    }


inputFromId(id){
  console.log(id)
  for(var i=0;i<this.props.inputs.length;i++){

    if(this.props.inputs[i].id==id){
      return this.props.inputs[i].name

    }

  }
  return "----"
}

logicString(){
  console.log("Show the string")
  console.log(this.props)


  try{

    let sensorID=this.props.data.logic[0].data.v1.var
    sensorID=this.inputFromId(sensorID.split("input")[1].split("filtered")[0])
    let duration=""
    let temperature=this.props.data.logic[0].data.v2.value
    if ("active_duration" in this.props.data){
      console.log("YES we have active duattion")
      var duration=this.props.data.active_duration
      console.log(this.props.data.active_duration)
      duration=parseInt(duration/60)+" minute"
      console.log(duration)
      if(this.props.data.active_duration!=60)
        duration=duration+"s"
    }
    console.log(duration)


  let opperator=this.props.data.logic[0].opperator
  let opperatortext={
    ">=":"above",
    "<=":"below"
  }
  console.log(duration)
  return (<span><b>{this.state.data.name}&nbsp;</b>{sensorID} is <b>{opperatortext[opperator]}</b> <span className="largerText">{temperature}</span> for <span className="largerText">{duration}</span></span>)

}catch(err){
  console.log(this.state.data)
  return (<span><b>{this.state.data.name}</b>  <span className="largerText">{this.state.data.state}</span></span>)
}

}


saveLogic=(e)=>{
  console.log("SAVE LOGIC!!!!!/\/\/\/\/\/\/\/\/")
  //Lets check we have a valid input!
  if(this.state.data.logic[0].data.v1.var=="inputXfiltered"){
    alert("Please Select a sensor!")
    return
  }

  console.log("save logic")
  console.log(this.state.id)
  console.log(this.state.data)




  console.log("Macro!")
  console.log(this.state.data.MacroTrue)
  console.log(this.state.macro)
  let d={
    cmd:"save",
    macro:this.state.macro,
    macro_index:this.state.data.MacroTrue,
    logic:this.state.data,
    logic_index:this.state.id
  }
  //Reset the logics state!
  d.logic.state="X"
  this.props.callback(d)

}
getValidationState=(e)=>{
  console.log("Validate?")
  console.log(e)
}


startEdit=()=>{
  console.log("EDIT")
  console.log(this.state.id)
  this.props.callback({"cmd":"edit","id":this.state.id})
}


delete=()=>{

  let d={
    cmd:"delete",
    macro_index:this.state.data.MacroTrue,
    logic_index:this.state.id
  }

  this.props.callback(d)


}
cancel=()=>{
  this.props.callback({"cmd":"cancel"})
}

new=()=>{
  this.props.callback({"cmd":"new"})
}




    render(){
      let stateClass="eventFalse"





    //  console.log(this.props)
      if(this.props.hasOwnProperty("data")){
      if(this.props.data.state==true){
        stateClass="eventTrue"
      }


      if (this.props.data.state==true && this.props.alert==true){
          return (<Well bsSize="small" className={stateClass+" eventAlert event"+this.props.data.level} key={this.props.logicid}><p title={new Date(this.props.data.time*1000)}>{this.logicString()} <br/><i>Active Since:<Moment fromNow>{new Date(this.state.data.time*1000-2000)}</Moment></i></p></Well>)
      }
    }

      if(this.props.showAll==true ){
        if( "active_duration" in this.props.data)
          return (<Well bsSize="small" className={stateClass+" eventAlert event"+this.props.data.level} key={this.props.logicid}><p title={new Date(this.props.data.time*1000)}>{this.logicString()} <br/></p></Well>)
        else{
            return (<Well bsSize="small" className={stateClass+" eventAlert event"+this.props.data.level} key={this.props.logicid}><p title={new Date(this.props.data.time*1000)}>{this.logicString()} <br/></p></Well>)
            //<Well bsSize="small" className={stateClass+" eventAlert event"+this.props.data.level} key={this.props.logicid}><p title={new Date(this.props.data.time*1000)}>{this.logicString()} <br/><i>Last Active:<Moment fromNow>{new Date(this.state.data.time*1000-2000)}</Moment></i></p></Well>)
        }
      }
      if (this.props.alert==true){
          return <span key={this.props.logicid}></span>
      }

      if(this.state.edit==true)
      return (<div>
              <h1>IF  <span className="summaryText ">{this.logicString()}</span></h1>
              {
                /*
              <ToggleButtonGroup
              className="pull-right"
                      type="radio"
                      name="options"
                      value={this.state.data.level}
                      onChange={this.changeLevel}
                    >
                      <ToggleButton value={1} className="level1">Good</ToggleButton>
                      <ToggleButton value={3} className="level3">Bad</ToggleButton>
                </ToggleButtonGroup>
                */}
              {/*}<h3>Select temperature sensor</h3>*/}
              <FormGroup controlId="formControlsSelect">
                  <ControlLabel>Choose a sensor</ControlLabel>
                  <FormControl componentClass="select" placeholder="select" onChange={this.updatedSensor} value={this.state.data.logic[0].data.v1.var}>
                  <option value="inputXfiltered">Select Sensor</option>
                    {this.props.inputs.map((l,i) =><ShowTempOption data={l} key={l.id}></ShowTempOption>)}
                  </FormControl>
              </FormGroup>


              <ToggleButtonGroup

                      type="radio"
                      name="options"
                      value={this.state.data.logic[0].opperator}
                      onChange={this.changeOpperator}
                    >
                      <ToggleButton value={">="}>Above</ToggleButton>
                      <ToggleButton value={"<="}>Below</ToggleButton>
                </ToggleButtonGroup>

              <FormGroup controlId="formBasicText">
                <ControlLabel>Enter a temperature in celsius °C</ControlLabel>
                  <InputGroup>
                    <FormControl
                      type="number"
                      value={this.state.data.logic[0].data.v2.value}
                      placeholder="Enter Temeprature"
                      min={-40}
                      max={80}
                      onChange={this.changeTemp} />
                    <FormControl.Feedback />
                    <InputGroup.Addon>°C</InputGroup.Addon>
                  </InputGroup>
                  <HelpBlock>Temperture should be in range -40°C to 80°C</HelpBlock>
              </FormGroup>
              <h3>Duration</h3>
                  <ToggleButtonGroup
                      type="radio"
                      name="options"
                      value={this.state.data.active_duration}
                      onChange={this.changeDuration}
                  >
                  <ToggleButton value={60}>1 minute</ToggleButton>
                  <ToggleButton value={900}>15 minutes</ToggleButton>
                  <ToggleButton value={1800}>30 minutes</ToggleButton>
                  <ToggleButton value={2700}>45 minutes</ToggleButton>
                  <ToggleButton value={3600}>60 minutes</ToggleButton>
                  <HelpBlock>How long must the temperature be out of range before raising alert</HelpBlock>
                  </ToggleButtonGroup>
              <h1>Then...</h1>
              <h4>Alert everyone in the following contact list</h4>
              <FormGroup controlId="formControlsSelect">
                  <ControlLabel>Select a contact list</ControlLabel>
                  <FormControl componentClass="select" placeholder="select" onChange={this.updatedContactList} value={this.state.macro.actions[0].list}>
                  <option value="None">Select a list</option>
                    {this.props.vars.map((l,i) =><ShowContactOption data={l} key={l.id}></ShowContactOption>)}
                  </FormControl>
                </FormGroup>
                {!this.state.new?(<Button className="pull-right" onClick={this.delete}>Delete</Button>):(<span></span>)}

<Button className="pull-right" onClick={this.saveLogic}>Save</Button>
<Button className="pull-right" onClick={this.cancel}>Cancel</Button>
<br/>
<br/>
<br/>

        </div>)
        else{
            if(this.props.new==true){
                          return (<Button onClick={this.new}>Create New</Button>)
              }
            else{
              if( "active_duration" in this.props.data)
                return (<Well bsSize="small" key={this.props.logicid}><div><span>{this.logicString()}</span><Button className="pull-right" onClick={this.startEdit} >Edit</Button></div></Well>)
                else {
                  return(<span></span>)
                }
            }
        }

    }
}



// WEBPACK FOOTER //
// ./src/programmerComponents/TempAlert.js